import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [RouterModule, MatIconModule, MatButtonModule, MatTooltipModule],
})
export class SidebarComponent implements OnInit {

  // Données reçues du composant parent (AppComponent)
  @Input() collapsed   = false;
  @Input() roles:      string[] = [];
  @Input() isDarkTheme = false;

  // Événements envoyés vers le parent quand l'utilisateur interagit
  @Output() toggleCollapse = new EventEmitter<void>();
  @Output() themeToggle    = new EventEmitter<void>();

  // true si l'utilisateur connecté est administrateur
  isAdmin = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin();
  }

  onToggle(): void {
    this.toggleCollapse.emit();
  }

  onThemeToggle(): void {
    this.themeToggle.emit();
  }
}
